import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Table, Tooltip, 
    Modal, Popconfirm, Pagination, Empty, Select,
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateBook, addTemplateBook, deleteTemplateBook, deleteBook, getDocuments,
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentBook = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [dataList, setDataList] = useState<any[]>([]);
    const [bookId, setBookId] = useState<string>("");
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [sourceType, setSourceType] = useState<string>("Url");
    const [documents, setDocuments] = useState<any[]>([]);

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo();
    }, [])
    const getDataInfo = (index=pageIndex, size=pageSize) => {
        getTemplateBook(templateId, {pageIndex: index, pageSize: size}).then((res) => {
            const {dataList, pageIndex, pageSize, totalCount} = res;
            if (dataList.length > 0) {
                setShowTable(2)
                setDataList(dataList);
                setPageIndex(pageIndex);
                setPageSize(pageSize);
                setTotalCount(totalCount);
            } else {
                setShowTable(1);
                setDataList([]);
            }
            getDocuments({search: ""}).then((data) => { setDocuments(data) })
        })

    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            if (isEdit) {
                res.id = bookId;
            }
            if (res.sourceType === "Url") {
                res.documentId = "";
            }
            if (res.sourceType === "Document") {
                res.title = "title";
                res.url = "url";
            }
            addTemplateBook(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                setBookId("");
                setIsModalVisible(false);
                setIsEdit(false);
                getDataInfo();
                setSourceType("Url");
            })
        })
    }
    const deleteTemplateClick = () => {
        deleteTemplateBook(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            getDataInfo();
        })
    }

    const onEdit = (res: any) => {
        setSourceType(res.sourceType);
        setBookId(res.id);
        dataForm?.setFieldsValue(res);
    }

    const onDeleteBook = (bookId: string) => {
        deleteBook(templateId, bookId).then(
            () => { notification.success({message: t("移除成功")}) },
            () => { notification.error({message: t("移除失败")}) }
        ).finally(
            () => { getDataInfo(); updateTemplate(); }
        )
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("Book")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("使用此配置文件需添加的图书,用户可以使用图书App打开")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentContent", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <div className="tAr">
                            <Button 
                                type="primary" 
                                onClick={() => { 
                                    setIsModalVisible(true);
                                    dataForm.resetFields();
                                }}
                            ><PlusOutlined />{t("添加图书")}</Button>
                        </div>
                        <div style={{width: "100%"}}>
                            <Table 
                                dataSource={dataList} 
                                rowKey={(row) => row.id} 
                                pagination={false}
                                style={{ width: "100%" ,marginLeft:8}}
                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                            >
                                <Column title={t("标题")} key="title" dataIndex="title"></Column>
                                {/* <Column title={t("链接")} key="url" dataIndex="url" 
                                    ellipsis={{"showTitle": false}}
                                    render={(url) => {
                                        return (
                                            <Tooltip placement="topLeft" title={url}>
                                                {url}
                                            </Tooltip>
                                        )
                                    }}
                                ></Column> */}
                                <Column
                                    title={t("操作")}
                                    key="id"
                                    dataIndex="id"
                                    render={(value, row, index) => {
                                        return (
                                            <>
                                                <Button type="link" onClick={() => { 
                                                    onEdit(row);
                                                    setIsModalVisible(true); 
                                                    setIsEdit(true);
                                                }}>{t("编辑")}</Button>
                                                <Popconfirm 
                                                    title={`${t("确认移除")}?`} 
                                                    onConfirm={() => { onDeleteBook(value) }}
                                                    okText={t("确认")}
                                                    cancelText={t("取消")}
                                                >
                                                    <Button type="text" danger>{t("移除")}</Button>
                                                </Popconfirm>
                                            </>
                                        )
                                    }}></Column>
                            </Table>
                            <Pagination
                                style={{ textAlign: "right", marginTop: "20px" }}
                                pageSize={pageSize}
                                current={pageIndex}
                                total={totalCount}
                                showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
                                onChange={(page, pageSize) => { getDataInfo(page, pageSize) }}
                                onShowSizeChange={(current, size) => { getDataInfo(current, size) }}
                            ></Pagination>
                        </div>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "80%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { notification.success({message: t("保存成功")}) }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentWifi", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
            <Modal
                maskClosable={false}
                open={isModalVisible}
                title={`${isEdit ? t('编辑图书') : t('添加图书')}`}
                width="650px"
                onOk={addTemplateClick}
                onCancel={() => { 
                    setIsModalVisible(false);
                    setIsEdit(false);
                    dataForm.resetFields();
                    setSourceType("Url");
                }}
                okText={t("确认")}
                cancelText={t("取消")}
            >
                <Form
                    style={{ width: "90%", marginTop: 36, marginLeft: 45 }}
                    layout="vertical"
                    form={dataForm}
                    labelCol={{ span: 24 }}
                    initialValues={{sourceType: t("Url")}}
                >
                    <Item label={t("图书来源")} name="sourceType" rules={[{ required: true }]}>
                        <Select
                            onChange={
                                (v: string) => {
                                    setSourceType(v);
                                    if (v === "Url") {
                                        dataForm.resetFields()
                                    }
                                }
                            }
                        >
                            <Select.Option value="Url">{t("自定义链接")}</Select.Option>
                            <Select.Option value="Document">{t("文档模块")}</Select.Option>
                        </Select>
                    </Item>
                    <Item label={t("标题")} name="title" rules={[{ required: sourceType === "Url" }]} hidden={sourceType !== "Url"}>
                        <Input></Input>
                    </Item>
                    <Item label={t("链接")} name="url" rules={[{ required: sourceType === "Url" }]} hidden={sourceType !== "Url"} extra={<><InfoCircleOutlined /> {t("链接不能有空格或特殊字符")}</>}>
                        <Input></Input>
                    </Item>
                    <Item label={t("选择文档")} name="documentId" rules={[{ required: sourceType === "Document" }]} hidden={sourceType === "Url"} extra={<><InfoCircleOutlined /> {isEdit ? t("仅支持相同文件类型间进行替换") : t("仅支持PDF以及gzip格式的EPUB文件")}</>}>
                        <Select
                            showSearch
                            placeholder={t("Select a document")}
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {
                                Array.isArray(documents) ? documents.map(
                                    document => <Select.Option key={document.id} value={document.id}>{document.title}</Select.Option>
                                ) : ""
                            }
                        </Select>
                    </Item>
                </Form>
            </Modal>
        </div>
    </>);
};